import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import LoadingPlaceholder from "designSystem/components/placeholder/LoadingPlaceholder";
import React from "react";

const PREFIX = "LoadingSlack";

const classes = {
	root: `${PREFIX}root`,
};

const StyledGrid = styled(Grid)({
	[`&.${classes.root}`]: {
		alignItems: "center",
		flex: 1,
		height: "100%",
		justifyContent: "center",
		width: "100%",
	},
});

const LoadingSlack: React.FunctionComponent<{}> = () => {
	return (
		<StyledGrid
			className={classes.root}
			container
			direction="column"
			item
		>
			<LoadingPlaceholder
				subtitleProps={{ res: "LoadingSlackSubtitle" }}
				titleProps={{ res: "Loading" }}
			/>
		</StyledGrid>
	);
};
export default LoadingSlack;
